import axios, { AxiosResponse } from 'axios';

export const CUSTOM_SIGNIN_ROUTE = `/api/auth/signin`;
export const CUSTOM_SIGNIN_ROUTE_OTP = `/api/auth/signin/otp`;
export const CUSTOM_SIGNIN_ROUTE_OTP_VERIFY = `/api/auth/signin/otp/verify`;

export const signIn = (data: { email: string; password: string; recaptchaToken: string }): Promise<AxiosResponse<any>> => {
    return axios.post(CUSTOM_SIGNIN_ROUTE, data);
};

export const getOTP = (data: { email: string; recaptchaToken?: string }): Promise<AxiosResponse<any>> => {
    return axios.post(CUSTOM_SIGNIN_ROUTE_OTP, data);
};

export const verifyAndLogin = (data: { user_id: string; otp: string; request_id: string }): Promise<AxiosResponse<any>> => {
    return axios.post(CUSTOM_SIGNIN_ROUTE_OTP_VERIFY, data);
};
